import React from 'react';
import { useHistory, useLocation } from 'react-router';
import TalentInvoiceInformation from 'components/TalentInvoiceInformation';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import TalentNavbar from 'components/TalentNavbar';
import TalentPageLayout from 'components/TalentPageLayout';
import { PageContainer } from 'components/PageContainer';

export default function PaymentInformationPage() {
  const history = useHistory();
  const location = useLocation<{invoiceId?: number}>();
  const invoiceId = Number(location.state?.invoiceId);
  const close = () => history.length > 1 ? history.goBack() : history.replace('hygienistInvoices');
  const hygienist = (window as any).TempStars?.User?.getCurrentUser?.()?.hygienist;
  return <TalentPageLayout navbar={<TalentNavbar
    firstName={hygienist?.firstName || ''}
    lastName={hygienist?.lastName || ''}
    photoUrl={hygienist?.photoUrl || undefined}
    instabookActivated={hygienist?.InstabookActivated === 1}
    isTestAccount={hygienist?.isTest === 1}
    showAddShiftButton={false}
    showJobBoardButton={false}
  />}>
    <PageContainer data-testid="payment-information-page">
      <StyledButton onClick={close} data-testid="payment-information-back">Back</StyledButton>
      {Number.isSafeInteger(invoiceId) && invoiceId > 0
        ? <TalentInvoiceInformation invoiceId={invoiceId} initiallyOpen onClose={close} />
        : <p>Open the payment information request from your notification bell or invoice.</p>}
    </PageContainer>
  </TalentPageLayout>;
}
